// cross browsers addRule method
export function addCSSRule(sheet, selector, rules, index) {
  'insertRule' in sheet ?
    sheet.insertRule(selector + '{' + rules + '}', index) :
    sheet.addRule(selector, rules, index);
}


//////////////////
// WEBPACK FOOTER
// ../work/src/~/tiny-slider/src/helpers/addCSSRule.js
// module id = 27
// module chunks = 0